// Preserve Shopify's checkout behavior and branded wallet buttons.
class LevayoCheckoutLabel extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.label) return;
    const update = () => {
      this.querySelectorAll('button.shopify-payment-button__button--unbranded').forEach(button => {
        if (button.textContent !== this.dataset.label) button.textContent = this.dataset.label;
        if (button.hasAttribute('aria-label') && button.getAttribute('aria-label') !== this.dataset.label) {
          button.setAttribute('aria-label', this.dataset.label);
        }
      });
    };
    this.observer = new MutationObserver(update);
    this.observer.observe(this, { childList: true, subtree: true, characterData: true });
    update();
  }
  disconnectedCallback() { this.observer?.disconnect(); }
}
if (!customElements.get('levayo-checkout-label')) customElements.define('levayo-checkout-label', LevayoCheckoutLabel);
